<template>
    <el-form :model="formData" inline size="small">
        <zj-date-picker
            label=""
            prop="updateTime"
            style="margin-right: 10px"
            type="datetimerange"
            v-model="formData.updateTime"
            placeholder="项目更新时间"/>
        <el-form-item prop="State">
            <el-select v-model="formData.State" placeholder="项目状态" clearable>
                <el-option v-for="(value, key) in QUESTION_STATUS"
                           :key="parseInt(key)"
                           :label="value"
                           :value="parseInt(key)" />
            </el-select>
        </el-form-item>
        <el-form-item prop="keyWord">
            <el-input type="text" v-model="formData.keyWord" placeholder="问卷名称"/>
        </el-form-item>
        <el-button type="primary" size="small" icon="el-icon-search" @click.stop="handleSearch"/>
        <el-button type="danger" size="small" icon="el-icon-refresh" @click.stop="handleReset" title="重置"/>
    </el-form>
</template>

<script>
import { QUESTION_STATUS } from "@/utils/question-config"
export default {
    name: "SearchForm",
    data() {
        return {
            // 项目状态
            formData: {}, // 表单数据
            QUESTION_STATUS
        }
    },
    methods: {
        handleSearch () {
            const { updateTime = [], ...otherProps } = this.formData
            this.$emit("search", Object.assign(otherProps, {
                startTime: updateTime[0],
                endTime: updateTime[1]
            }))
        },
        handleReset () {
            this.formData = {}
            this.handleSearch()
        }
    }
}
</script>

<style scoped>

</style>
